export const PACKAGE_NAME = 'jira-enforce-storage-limits';
export const LOCAL_STORAGE_LAST_ENFORCED_KEY = 'lastStorageEnforcement';
